import { datadogLogs } from '@datadog/browser-logs';
import { environment } from '../../../environments/environment';
import { Dictionary } from 'types';

export function debug(logMessage: string, messageContext: Dictionary<any>) {
    log(MonitoringLogType.Debug, logMessage, messageContext);
}

export function info(logMessage: string, messageContext: Dictionary<any>) {
    log(MonitoringLogType.Info, logMessage, messageContext);
}

export function warn(logMessage: string, messageContext: Dictionary<any>) {
    log(MonitoringLogType.Warn, logMessage, messageContext);
}

export function error(logMessage: string, messageContext: Dictionary<any>) {
    log(MonitoringLogType.Error, logMessage, messageContext);
}

function log(type: MonitoringLogType, logMessage: string, messageContext: Dictionary<any>) {
    const logTypeToConsoleMap = {
        [MonitoringLogType.Error]: 'error',
        [MonitoringLogType.Warn]: 'warn',
        [MonitoringLogType.Info]: 'log',
        [MonitoringLogType.Debug]: 'log'
    };

    try {
        if (isDataDogEnabled() && datadogLogs.logger?.[type]) {
            return datadogLogs.logger[type](logMessage, messageContext);
        }

        console[logTypeToConsoleMap[type]](logMessage, messageContext); // eslint-disable-line no-console
    } catch (error) {
        console.error(error);
    }
}

function isDataDogEnabled() {
    return environment.DD_ENABLED;
}

enum MonitoringLogType {
    Error = 'error',
    Warn = 'warn',
    Info = 'info',
    Debug = 'debug'
}
